{
  "TelnosmovedtoLabel": "Numéro(s) de téléphone déplacé(s) vers :",
  "DevicesmovedfromLabel": "Dispositif(s) déplacé(s) de :",
  "AcdagentsmovedfromLabel": "Agent(s) ACD déplacé(s) de :",
  "CallsegmentnumberLabel": "Numéro de segment d'appel :",
  "CallsegmentnumberAnyOptionLabel": "[N'importe lequel]",
  "CallsegmentnumberFirstOptionLabel": "[Premier]",
  "Callsegmentnumber2OptionLabel": "2",
  "Callsegmentnumber3OptionLabel": "3",
  "Callsegmentnumber4OptionLabel": "4",
  "Callsegmentnumber5OptionLabel": "5",
  "Callsegmentnumber6plusOptionLabel": "6+",
  "CallsegmentnumberLastOptionLabel": "[Dernière]",
  "CallsegmentstartreasonLabel": "Raison du début du segment d'appel :",
  "CallsegmentstartreasonAnyOptionLabel": "[N'importe lequel]",
  "CallsegmentstartreasonDivertedtoOptionLabel": "Détourné vers",
  "CallsegmentstartreasonOverflowedinOptionLabel": "Débordé dans",
  "CallsegmentstartreasonAdvancedtoOptionLabel": "Avancé à",
  "CallsegmentstartreasonTransferredtoOptionLabel": "Transféré à",
  "CallsegmentstartreasonConferencedtoOptionLabel": "Conférence à",
  "CallsegmentstartreasonConferencedegenOptionLabel": "Conférence De\/Gen",
  "CallsegmentendreasonLabel": "Raison de la fin du segment d'appel :",
  "CallsegmentendreasonAnyOptionLabel": "[N'importe lequel]",
  "CallsegmentendreasonDivertedfromOptionLabel": "Détourné de",
  "CallsegmentendreasonOverflowedoffOptionLabel": "Débordé Off",
  "CallsegmentendreasonAdvancedfromOptionLabel": "Avancé De",
  "CallsegmentendreasonTransferredfromOptionLabel": "Transféré de",
  "CallsegmentendreasonConferencedfromOptionLabel": "Conférence de",
  "CallsegmentendreasonConferencedegenOptionLabel": "Conférence De\/Gen",
  "CallsegmentendreasonConsultationtrtoOptionLabel": "Consultation Tr\/To",
  "CallsegmentendreasonMovedtoconferenceOptionLabel": "Déplacé à la conférence",
  "CallsegmentendreasonMovedtoparkOptionLabel": "Déplacé vers le parc",
  "CallsegmentendreasonMovedtovoicemailOptionLabel": "Déplacé vers la messagerie vocale",
  "CallsegmentendreasonEndedonholdonlyOptionLabel": "Terminé en attente seulement",
  "CallsegmentendreasonEndedonholdexclOptionLabel": "Terminé En attente Exclus",
  "CallsegmentendreasonUnmonitoreddestOptionLabel": "Destination non surveillée",
  "CallsegmentendreasonUnknowndestOptionLabel": "Destination inconnue",
  "CallsegmentendreasonAllunrslvddestonlyOptionLabel": "Toutes les destinations non résolues uniquement",
  "CallsegmentendreasonAllunrslvddestexclOptionLabel": "Toutes les destinations non résolues sont exclues",
  "CallsegmentendreasonModellingerrorsonlyOptionLabel": "Erreurs de modélisation uniquement",
  "CallsegmentendreasonModellingerrorsexclOptionLabel": "Erreurs de modélisation exclues",
  "CallsegmentendreasonApplicationendedOptionLabel": "Application finie",
  "CallsegmentendreasonDevicedeletedOptionLabel": "Dispositif supprimé",
  "CallsegmentendreasonNoreplyneededEmailsexcludedOptionLabel": "Les courriels sans réponse sont exclus",
  "CallsegmentchainidLabel": "ID de la chaîne de segments d'appel (ID d'appel de l'application) :",
  "CallMovementFiltering_SectionHeader": "Filtrage des mouvements d'appels",
  "CallMovementFiltering_AnyPlaceholder": "[N'importe lequel]",
  "NAME": "CallMovementFiltering",
  "AcdagentsmovedfromLabel_MST": "Agent(s) déménagé(s) de :",
  "CallsegmentstartreasonEscapedtoOptionLabel": "S'échapper vers",
  "CallsegmentendreasonEscapedfromOptionLabel": "Échappée"
}